module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKklEQVQ4T62TzYqCcBTFz9UZEFtoIvgC0caXaOsLtIiCFhK5dN5iNmMr6QHcBO7FTevWQdDeVeDH3ibvYExB4AjW/Lfnf3+c+3FIUZRPInKJ6B0dHjOfmdkjVVXPRPTWofb+lZm/qd/v8zPFt5r/BZimCcuyIIpio6nL5YIoinA4HO76g4PdbofhcNja0X6/x2g0agYMBgOMx2M4joNer/cAyrIMnudhu93ieDw2A5IkwXq9xmazgW3bmM/nKMsSvu8jDEMsl0vMZjMYhtEMyPP8KhRFgdVqhTiOUVUVJpMJFosFZFm+6pqmtQNu6ul0giRJUBTloZ0/AWmaQhCE1iHWjnRdb3ZQD2k6nbauMQgCuK7bDHjmIl+/xBfDdKbfOH90TWSdRGb++gH8CHsqyimJ1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about_mobile/13.png
// module id = A9XR
// module chunks = 1